<template>
    <div class="container">
            <div class="card blue-grey darken-1">
              <div class="card-content white-text">
                <span class="card-title">Congratulations!</span>
                <p>Well done {{ name }}! You have completed all your sessions for this week. It is time to come back home...</p>
              </div>
              <div class="card-action">
                <a class="waves-effect waves-light" v-on:click="gotoNext()">Jump into the next week of training
                </a>
              </div>
            </div>
            
          </div>  
</template>

<script>
import api from '@/api'
export default {
  name: 'trackBodyRemind',
  props: {
    'name': String,
    'user': Object,
    'callback': Function
  },
  methods: {
    gotoNext () {
      this.user.athlete.gotoNextSessions = true
      this.user.athlete.doneActions = {} // reset actions performed on the past week
      api.getNextSessions(this.user) // weird. update is performed here
      if (this.callback) this.callback(this.user)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/cards/SessionCompleted.vue